<ng-container *ngIf="initialized">
  <form class="form" (ngSubmit)="onSave()" novalidate>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add A Note</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="font-size-1" for="exampleFormControlInput1">HINT: type '@' followed by someone's name to notify them of your comment.</label>
              <textarea [mention]="items" style="height: 200px" class="form-control" [(ngModel)]="noteText" [mentionConfig]="{ disableSearch: true }" (searchTerm)="searchTerm($event)" name="noteEntry" placeholder="Send your colleage a notification by typing @ followed by their name. Only users in your organization can see notes."></textarea>

              <div class="invalid-message">
                <div>Note Text is required</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-sm btn-secondary mr-2" [disabled]="!noteText || noteText.length == 0" [promiseBtn]="submitComplete" type="submit">
              <span>Add Note</span>
            </button>
            <button class="btn btn-sm btn-outline-dark" (click)="onCancel()" type="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
